import React from 'react'

import { TabelaColuna } from 'src/componentes'

export const colunaNotaAproveitada = (): TabelaColuna => ({
  Chave: 'notaAproveitada',
  ComOrdenacao: true,
  RenderizarCabecalho: () => <div style={{ width: 130 }}>Nota Aproveitada</div>
})
